import type { JSX } from 'react';
import { Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client.js';
import { AsyncSection } from '../components/AsyncSection.js';
import { DataTable } from '../components/DataTable.js';

interface AuditRow {
  id: string;
  actorId: string | null;
  actorRole: string | null;
  action: string;
  objectType: string;
  objectId: string | null;
  circleId: string | null;
  reason: string | null;
  createdAt: string;
}

export function AuditPage(): JSX.Element {
  const query = useQuery({
    queryKey: ['admin', 'audit'],
    queryFn: () => api.get<{ items: AuditRow[] }>('/v1/admin/audit?limit=100'),
  });

  return (
    <>
      <Typography variant="h1" gutterBottom>
        Auditoria
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Toda mudança de negócio e acesso excepcional entra aqui. Eventos sem ator
        identificado são ações de sistema (retenção, reconciliação).
      </Typography>
      <AsyncSection query={query} emptyMessage="Nenhum evento de auditoria.">
        {(data) => (
          <DataTable
            rows={data.items}
            getRowKey={(row) => row.id}
            emptyMessage="Nenhum evento de auditoria."
            columns={[
              {
                key: 'when',
                label: 'Quando',
                render: (row) => new Date(row.createdAt).toLocaleString('pt-BR'),
              },
              { key: 'action', label: 'Ação', render: (row) => row.action },
              { key: 'object', label: 'Objeto', render: (row) => `${row.objectType}${row.objectId ? ` (${row.objectId.slice(0, 8)}…)` : ''}` },
              { key: 'actor', label: 'Ator', render: (row) => row.actorRole ?? (row.actorId ? 'usuário' : 'sistema') },
              { key: 'reason', label: 'Motivo', render: (row) => row.reason ?? '—' },
            ]}
          />
        )}
      </AsyncSection>
    </>
  );
}